<div class="w-full sm:grid grid-flow-col grid-cols-2 grid-rows-3 gap-2.5 h-full mb-3 sm:mb-0">
    <div class="col-span-1 row-span-1">
      <app-history-chart></app-history-chart>
    </div>
    <div class="col-span-1 row-span-1 rounded-md bg-white">
      <a href="#">
        <div class="sm:h-full border border-[#D9D9D9] rounded-md overflow-hidden mb-2 sm:mb-0">
          <div class="w-full">
            <img class="h-auto sm:h-[151px] lg:h-auto xl:h-[151px] w-full object-cover" src="/assets/images/news/news.png" alt="news">
          </div>
          <div class="px-3 py-2">
            <p class="text-444 text-base/tight font-normal mb-2">How much gold can you legally carry from Dubai to India?</p>
            <p class="flex items-center justify-between">
              <a href="#" class=" capitalize font-normal text-xs text-[#898989] hover:text-c19725 hover:tracking-wide">Read News</a>
              <a href="#">
                <svg class="size-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960" fill="#0D5BAB"><path d="M647-440H160v-80h487L423-744l57-56 320 320-320 320-57-56 224-224Z"/></svg>
              </a>
            </p>
          </div>
        </div>
      </a>
    </div>
    <div class="col-span-1 row-span-1 rounded-xl">
      <a href="#">
        <div class="relative rounded-lg overflow-hidden w-full h-40 sm:h-full bg-[url('/assets/images/news/image-2.png')] bg-no-repeat bg-cover bg-center mb-2">
          <div class="absolute inset-0 bg-gradient-to-b from-white/5 via-[#5B463E]/50 to-[#2F0F02] z-1 flex items-end justify-between p-2 lg:p-4 gap-2">
            <p class="text-white w-[calc(100%-40px)] text-sm lg:text-xl xl:text-2xl font-bold">Best Gold Stocks in India 2025...</p>
            <svg class="size-5 lg:size-8" xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960" fill="#ffffff"><path d="M647-440H160v-80h487L423-744l57-56 320 320-320 320-57-56 224-224Z"/></svg>
          </div>
        </div>
      </a>
    </div>
    <div class="col-span-1 row-span-2">
      <ul class="p-3 rounded-md bg-radial-(--my-gradient7) border border-[#D9D9D9] mb-2 sm:mb-0 sm:h-full">
        <li class="py-3 border-b-1 border-[#D9D9D9] hover:bg-gray-50 last:border-b-0">
          <a href="#" class="flex items-start gap-2">
            <img class="size-7" src="/assets/images/news/news1.png" alt="news">           
            <p class="w-[calc(100%-40px)] text-444 font-medium text-base/tight capitalize line-clamp-2">24-Carat vs. 18-Carat Gold: What’s the Difference?</p>
          </a>
        </li>
        <li class="py-3 border-b-1 border-[#D9D9D9] hover:bg-gray-50 last:border-b-0">
          <a href="#" class="flex items-start gap-2">
            <img class="size-7" src="/assets/images/news/news2.png" alt="news">            
            <p class="w-[calc(100%-40px)] text-444 font-medium text-base/tight capitalize line-clamp-2">How Did France Circulate Faked Gold Coins?</p>
          </a>
        </li>
        <li class="py-3 border-b-1 border-[#D9D9D9] hover:bg-gray-50 last:border-b-0">
          <a href="#" class="flex items-start gap-2">
            <img class="size-7" src="/assets/images/news/news3.png" alt="news">            
            <p class="w-[calc(100%-40px)] text-444 font-medium text-base/tight capitalize line-clamp-2">Why a Gold Savings Account is Better Than Banking on Interest Rates</p>
          </a>
        </li>
        <li class="py-3 border-b-1 border-[#D9D9D9] hover:bg-gray-50 last:border-b-0">
          <a href="#" class="flex items-start gap-2">
            <img class="size-7" src="/assets/images/news/news4.png" alt="news">           
            <p class="w-[calc(100%-40px)] text-444 font-medium text-base/tight capitalize line-clamp-2">Gold vs. Other Precious Metals: Which is the Better</p>
          </a>
        </li>
        <li class="py-3 border-b-1 border-[#D9D9D9] hover:bg-gray-50 last:border-b-0">
          <a href="#" class="flex items-start gap-2">
            <img class="size-7" src="/assets/images/news/news5.png" alt="news">           
            <p class="w-[calc(100%-40px)] text-444 font-medium text-base/tight capitalize line-clamp-2">The Beginner’s Guide to Investing in Digital Silver</p>
          </a>
        </li>
        <li class="py-3 border-b-1 border-[#D9D9D9] hover:bg-gray-50 last:border-b-0">
          <a href="#" class="flex items-start gap-2">
            <img class="size-7" src="/assets/images/news/news6.png" alt="news">            
            <p class="w-[calc(100%-40px)] text-444 font-medium text-base/tight capitalize line-clamp-2">Why Buy Gold on Gudipadwa? The Untold Story Behind This Tradition</p>
          </a>
        </li>
        <li class="py-3 border-b-1 border-[#D9D9D9] hover:bg-gray-50 last:border-b-0">
          <a href="#" class="flex items-start gap-2">
            <img class="size-7" src="/assets/images/news/news7.png" alt="news">            
            <p class="w-[calc(100%-40px)] text-444 font-medium text-base/tight capitalize line-clamp-2">Investing in Land vs Gold: Which is Better?</p>
          </a>
        </li>
      </ul>
    </div>
    <div class="col-span-1 row-span-1 rounded-xl">
      <a href="#">
        <div class="relative rounded-lg overflow-hidden w-full h-40 sm:h-full bg-[url('/assets/images/news/image-1.png')] bg-no-repeat bg-cover bg-center mb-2 sm:mb-0">
          <div class="absolute inset-0 bg-gradient-to-b from-white/5 via-[#5B463E]/50 to-[#2F0F02] z-1 flex items-end justify-between p-2 lg:p-4 gap-2">
            <p class="text-white w-[calc(100%-40px)] text-sm lg:text-xl xl:text-2xl font-bold">Best Gold Stocks in India 2025...</p>
            <svg class="size-5 lg:size-8" xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960" fill="#ffffff"><path d="M647-440H160v-80h487L423-744l57-56 320 320-320 320-57-56 224-224Z"/></svg>
          </div>
        </div>
      </a>
    </div>
  </div>